import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBriefcase,
  faCube,
  faSparkles,
  faTable,
  faTimer,
} from "@fortawesome/pro-regular-svg-icons";

export const BLOCK_ICONS: Record<string, IconDefinition> = {
  sparkles: faSparkles,
  table: faTable,
  briefcase: faBriefcase,
  cube: faCube,
  clock: faTimer,
};

export const getBlockIcon = (
  iconKey: string | null | undefined,
): IconDefinition | null => {
  if (!iconKey) {
    return null;
  }

  return BLOCK_ICONS[iconKey] ?? null;
};
